import { getCookie } from 'cookies-next';
import {
  useGetApiBackOfficeUsersCurrentUserDetail,
  usePutApiBackOfficeUsersCurrentUserChangeDetail,
} from '@/api/backoffice/back-office-users/back-office-users';

const usePlayer = () => {
  const accessToken = getCookie('access_token');

  const { data, isLoading, error } = useGetApiBackOfficeUsersCurrentUserDetail({
    query: {
      enabled: !!accessToken, // Only fetch if the user is logged in
      refetchOnWindowFocus: true, // Refetch when the window regains focus
      refetchOnMount: true, // Refetch when the component mounts
    },
  });

  // Use the Orval-generated mutation for updating the current user detail
  const { mutateAsync: updatePlayerInfo } =
    usePutApiBackOfficeUsersCurrentUserChangeDetail();

  return { data, isLoading, error, updatePlayerInfo };
};

export default usePlayer;
